import React from "react";

import { Tabs } from "~/components/ui/tabs";
import { cn } from "~/utils";
import {
  StyledTabsNavigation,
  type StyledTabItem,
  type StyledTabsNavigationProps,
} from "./styled-tabs-navigation";

interface StyledTabsProps<T extends string = string>
  extends Omit<StyledTabsNavigationProps<T>, "activeTab"> {
  activeTab: T;
  onTabChange: (value: T) => void;
  children?: React.ReactNode;
  navigationClassName?: string;
}

export const StyledTabs = <T extends string = string>({
  activeTab,
  onTabChange,
  tabs,
  variant,
  children,
  className,
  triggerClassName,
  listClassName,
  navigationClassName,
}: StyledTabsProps<T>) => {
  const handleTabChange = (value: string) => {
    onTabChange(value as T);
  };

  return (
    <Tabs
      value={activeTab}
      onValueChange={handleTabChange}
      className={cn("gap-0", className)}
    >
      <StyledTabsNavigation
        tabs={tabs}
        activeTab={activeTab}
        variant={variant}
        className={navigationClassName}
        triggerClassName={triggerClassName}
        listClassName={listClassName}
      />
      {children}
    </Tabs>
  );
};

export type { StyledTabItem };
